:host {
  width: var(--wb-grid-width);
  margin: 0 auto;
  position: relative;
  display: block;
}

:host([full-width]) {
  max-width: 100%;
  width: 100%;
}
